import React, { FC, useState } from 'react'
import { Dialog } from '@ui/overlays/dialog/dialog';

import { DialogBody } from '@ui/overlays/dialog/dialog-body';
import { Button } from '@ui/buttons/button';

import { Trans } from '@ui/i18n/trans';
import { DialogFooter } from '@ui/overlays/dialog/dialog-footer';

import { TextField } from '@ui/forms/input-field/text-field/text-field';
import type { BPMValue } from '@player/types';

import { useDialogContext } from '@ui/overlays/dialog/dialog-context';

export interface BPMListProps {
    selected: BPMValue | null
    onSelect: (bpm: BPMValue) => void
    onClear?: () => void
}

export const BPMList: FC<BPMListProps> = ({ selected, onSelect, onClear }) => {
    const [from, setFrom] = useState<string>(selected?.from?.toString() || '')
    const [to, setTo] = useState<string>(selected?.to?.toString() || '')

    const { close } = useDialogContext()

    return (
        <Dialog>
            <DialogBody padding="p-0">
                <div className="grid p-20 grid-cols-2 gap-10">
                    <div>
                        <span className="block mb-1 text-muted text-xs">From</span>
                        <TextField
                            type="tel"
                            inputRadius="rounded"
                            value={from}
                            size="md"
                            placeholder="From"
                            onChange={(event) => {
                                const value = event.target.value
                                const regex = /^\d{0,6}(\.\d{0,2})?$/

                                if (value.length === 0 || regex.test(value)) {
                                    setFrom(value)
                                }
                            }}
                        />
                    </div>

                    <div>
                        <span className="block mb-1 text-muted text-xs">To</span>
                        <TextField
                            type="tel"
                            inputRadius="rounded"
                            value={to}
                            size="md"
                            placeholder="To"
                            onChange={(event) => {
                                const value = event.target.value
                                const regex = /^\d{0,6}(\.\d{0,2})?$/

                                if (value.length === 0 || regex.test(value)) {
                                    setTo(value)
                                }
                            }}
                        />
                    </div>
                </div>
                <DialogFooter className="border-t" padding="p-10">
                    <Button
                        variant="flat"
                        color="paper"
                        size="xs"
                        className="ml-auto rounded-sm"
                        onClick={() => {
                            close()
                            onClear?.()

                            setFrom('')
                            setTo('')
                        }}
                    >
                        <Trans message="Reset" />
                    </Button>

                    <Button
                        variant="flat"
                        color="primary"
                        size="xs"
                        className="ml-auto rounded-sm"
                        onClick={() => {
                            close()
                            onSelect({
                                from: Number(from) || 0,
                                to: Number(to) || 999
                            })
                        }}
                    >
                        <Trans message="Apply" />
                    </Button>
                </DialogFooter>
            </DialogBody>
        </Dialog>
    )
}
